import { Text } from "@mantine/core";
import Player from "react-lottie-player/dist/LottiePlayerLight";

import classes from "./BotListeningLoader.module.css";
import path from "./listeningLottie.json?url";

function BotListeningLoader() {
    return (
        <>
            <Player path={path} className={classes.player} loop play speed={1} />
            <Text c="dark.2" className={classes.text} fs="italic" fz="sm">
                Listening...
            </Text>
        </>
    );
}
export default BotListeningLoader;
